import {
  AccountIconUploader,
  Centralizer,
  DetailsInfo,
  Loading,
  Space,
} from '@/components';
import { useMe } from '@/features/authentication/_hooks/me';
import { useMessage } from '@/providers';
import { type FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useUpdateProfile } from '../_hooks/profile';

export const UserProfileContent: FC = () => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();
  const me = useMe();
  const { mutateAsync } = useUpdateProfile();
  const [iconUrl, setIconUrl] = useState('');

  const notChanged = me.data?.iconDataUrl === iconUrl;

  // biome-ignore lint/correctness/useExhaustiveDependencies: (migrate from ESLint)
  useEffect(() => {
    if (me.data) {
      setIconUrl(me.data.iconDataUrl ?? '');
    }
  }, [me.data?.iconDataUrl]);

  if (me.isPending || !me.data) {
    return <Loading />;
  }

  return (
    <Centralizer>
      <Space direction="vertical">
        <DetailsInfo
          items={[
            {
              label: t('name'),
              value: me.data.name,
            },
            {
              label: t('email'),
              value: me.data.email,
            },
          ]}
        />

        <AccountIconUploader
          iconUrl={iconUrl}
          onChange={(imgUrl) => {
            setIconUrl(imgUrl);
          }}
          onSave={
            !notChanged
              ? async () => {
                  await mutateAsync({
                    iconDataUrl: iconUrl,
                  });
                  openMessage('success', t('message-update-completed'));
                  await me.refetch();
                }
              : undefined
          }
          onClear={
            iconUrl
              ? () => {
                  setIconUrl('');
                }
              : undefined
          }
        />
      </Space>
    </Centralizer>
  );
};
